import { render } from "./migrate-mapping-list-progress.vue?vue&type=template&id=f098e94a"
import script from "./migrate-mapping-list-progress.vue?vue&type=script&lang=js"
export * from "./migrate-mapping-list-progress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__